<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import BmlrBrowse from "./BmlrBrowse";
import BmlrEdit from "./BmlrEdit";
import BmlrForm from "./BmlrForm";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "Bmlr",
    components: { BmlrBrowse, BmlrEdit, BmlrForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    created() {
        if (this.getNoticeId) {
            this.editProps.showEdit = true;
        }
    },
    computed: {
        ...userMapGetters(["getNoticeId"]),
        compName() {
            if (this.editProps.showEdit === true) {
                return "BmlrEdit";
            } else if (this.editProps.showForm === true) {
                return "BmlrForm";
            } else {
                return "BmlrBrowse";
            }
        }
    }
};
</script>
